import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=129d60e6&scoped=true&"
import script from "./declaration.vue?vue&type=script&lang=js&"
export * from "./declaration.vue?vue&type=script&lang=js&"
import style0 from "./declaration.vue?vue&type=style&index=0&id=129d60e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d60e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('129d60e6')) {
      api.createRecord('129d60e6', component.options)
    } else {
      api.reload('129d60e6', component.options)
    }
    module.hot.accept("./declaration.vue?vue&type=template&id=129d60e6&scoped=true&", function () {
      api.rerender('129d60e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/declaration/declaration.vue"
export default component.exports